<template>
  <section class="cursos-section">
    <h2>Cursos Ofertados</h2>
    <div class="cursos-container">
      <div class="curso-card" v-for="curso in cursos" :key="curso.id">
        <a :href="curso.linkGrupo" target="_blank">
          
        </a>
        
        <h3>{{ curso.titulo }}</h3>
        <p>{{ curso.descricao }}</p>
        
        <a :href="curso.linkGrupo" target="_blank" class="btn-detalhes">{{ curso.botaoTexto }}</a>
      </div>
    </div>

    <div class="saiba-mais-container">
      <a href="https://cursos.apollotech.com.br/" target="_blank" class="btn-saiba-mais">
        Saiba Mais
      </a>
    </div>
    </section>
</template>

<script>

export default {
  name: 'CursosSection',
  data() {
    return {
      cursos: [
        {
          id: 1,
          titulo: 'Lógica de Programação',
          descricao: 'Aprenda a pensar como um programador e crie a base para sua carreira em tecnologia.',
          
          botaoTexto: 'Grupo de Lógica',
          linkGrupo: 'https://t.me/Apollodev12_bot?start=vibx' // Exemplo de link para grupo do Telegram
        },
        {
          id: 2,
          titulo: 'Front-End com Bootstrap',
          descricao: 'Construa sites modernos e responsivos de forma rápida e eficiente utilizando Bootstrap.',
          
          botaoTexto: 'Comunidade Bootstrap',
          linkGrupo: 'https://t.me/Apollofront12_bot?start=vibx'
        },
        {
          id: 3,
          titulo: 'JavaScript',
          descricao: 'Domine a linguagem que move a web e crie interações dinâmicas e funcionalidades avançadas.',
       
          botaoTexto: 'Grupo de JS',
          linkGrupo: 'https://t.me/Apollojavas_bot?start=vibx'
        },
        {
          id: 4,
          titulo: 'Python',
          descricao: 'Explore a versatilidade de Python em desenvolvimento web, análise de dados e automação.',
          
          botaoTexto: 'Comunidade Python',
          linkGrupo: 'https://t.me/Apollopy12_bot?start=vibx'
        },
      ]
    };
  }
};
</script>

<style scoped>
/* Os estilos permanecem os mesmos, pois a estrutura HTML não mudou drasticamente. */
.cursos-section {
  padding: 40px 20px;
  background-color: transparent !important;
  text-align: center;
}

.cursos-section h2 {
  font-size: 2.5rem;
  color: #ffffff;
  margin-bottom: 30px;
}

.cursos-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
}

.curso-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 25px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.curso-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.curso-card h3 {
  font-size: 1.5rem;
  color: #555;
  margin-top: 0;
  margin-bottom: 10px;
}

.curso-card p {
  color: #777;
  line-height: 1.5;
  margin-bottom: 20px;
}

.btn-detalhes {
  display: inline-block;
  background-color: rgb(149, 193, 240);
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.btn-detalhes:hover {
  background-color: rgb(149, 193, 240);
}

/* --- NOVOS ESTILOS ADICIONADOS PARA O BOTÃO FINAL --- */
.saiba-mais-container {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.btn-saiba-mais {
  display: inline-block;
  background-color: #fff; /* Fundo branco para destacar */
  color: rgb(149, 193, 240); /* Texto na cor azul padrão do seu tema */
  padding: 15px 40px;
  border-radius: 50px; /* Borda bem arredondada */
  text-decoration: none;
  font-weight: 800; /* Fonte mais grossa */
  font-size: 1.2rem;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.btn-saiba-mais:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 15px rgba(0,0,0,0.3);
}
</style>